import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export declare interface ApiMusicSource {
  Default: OnsipAPIBoolean;
  MusicSourceId: string;
  Name: string;
  OrganizationId: string;
  Playlist: OnsipAPIBoolean; // boolean
  Url: string;
}

export interface MusicSource {
  default: boolean;
  musicSourceId: string;
  name: string;
  organizationId: string;
  playlist: boolean;
  url: string;
}

export interface MusicSourceAdd {
  name: string;
  url: string;
}

export interface MusicSourceEdit extends MusicSourceAdd {
  musicSourceId: string;
}

export function apiMusicSourceToMusicSource(apiMusicSource: ApiMusicSource): MusicSource {
  return {
    default: onsipApiBooleanToBoolean(apiMusicSource.Default),
    musicSourceId: apiMusicSource.MusicSourceId,
    name: apiMusicSource.Name,
    organizationId: apiMusicSource.OrganizationId,
    playlist: onsipApiBooleanToBoolean(apiMusicSource.Playlist),
    url: apiMusicSource.Url
  };
}
